
import { defineComponent, ref, onMounted, computed } from "vue";
import { useMessage, useThemeVars, StepProps, ButtonProps,SelectProps  } from "naive-ui";
import HosterInfo from "@/components/hoster/editor/hosterInfo.vue";
import HosterInvite from "@/components/hoster/editor/hosterInvite.vue";
// import HosterDate from "@/components/hoster/editor/hosterDate.vue";
import HosterConfirm from "@/components/hoster/editor/hosterConfirm.vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { MdArrowRoundBack, MdArrowRoundForward } from "@vicons/ionicons4";
import store from "@/store";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as hosterModule,
  Actions as hosterActions,
  Getters as hosterGetters,
} from "@/store/enums/hosterEnums";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import inviteAvailableTimeInterface from "@/core/models/share/inviteAvailableTime.interface";
import inviteDateModel from "@/core/models/hoster/inviteDate.interface";
import inviteInfoModel from "@/core/models/hoster/inviteInfo.interface";
import invitaDateTimeModel from "@/core/models/hoster/inviteDateTime.interface";
type SelectThemeOverrides = NonNullable<SelectProps['themeOverrides']>
type ButtonThemeOverrides = NonNullable<ButtonProps['themeOverrides']>


export default defineComponent({
  props: {
    showModal: Boolean,
    actionModal: String,
  },
  components: {
    HosterInfo: HosterInfo,
    HosterInvite: HosterInvite,
    // HosterDate: HosterDate,
    HosterConfirm: HosterConfirm,
    MdArrowRoundBack,
    MdArrowRoundForward,
  },
  emits: ["showModalClose"],
  setup(props: any, context: any) {
    const loadingRef = ref(false);
    const message = useMessage();
    const currentRef = ref<any>(1);
    const themeVars = useThemeVars();
    const resolution = computed<inviteEventModel>(
      () => store.getters[hosterModule.desc + hosterGetters.Resolution]
    );
    const stepThemeOverrides: StepProps = {
      // headerTextColorProcess: "#fff"
      status: 'process'
    }
    const inviteInfo = computed<inviteInfoModel>(
      () => store.getters[hosterModule.desc + hosterGetters.InviteInfo]
    );
    const invitMember = computed<Array<invitePersonModel>>(
      () => store.getters[hosterModule.desc + hosterGetters.InvitMember]
    );
    const inviteDate = computed<Array<inviteDateModel>>(
      () => store.getters[hosterModule.desc + hosterGetters.InviteDate]
    );
    const intervalMinutes = computed(
      () => store.getters[hosterModule.desc + hosterGetters.IntervalMinutes]
    );
    
    let inviteScheduler = computed<Array<inviteDateModel>>(
      () => store.getters[hosterModule.desc + hosterGetters.InviteScheduler]
    );
    
    function onClose() {
      context.emit("showModalClose", false);
      currentRef.value = 1;
    }
    async function onSubmit() {
      //console.log(props.actionModal)
      let InitData: inviteEventModel = {
        EventHeaderId: "0",
        Title: inviteInfo.value.EventName,
        Description: inviteInfo.value.EventContext,
        SubmitDueDateUTCDateTime: new Date(inviteInfo.value.ReplayDealine).toISOString(),
        IntervalMinutes: intervalMinutes.value.data,
        HosterMemberId: "",
        HasReply: ParamHasReply.No,
        Location: "",
        Comment: "",
        Status: inviteInfo.value.Status,
        HeadCount: 1,
        ResponseCount: 0,
        ApplierMemberId: "",
        IsResolution: ParamIsResolution.NotYet,
        TimeOffset: dayjs( ).utcOffset(),
      };
      //console.log(InitData);
      //console.log(inviteInfo.value.ReplayDealine);
      //console.log(InitData.SubmitDueDateUTCDateTime)

      let InitDataPerson: Array<invitePersonModel> = [
      ];

      invitMember.value.forEach((item: invitePersonModel, index: any) => {
        let personDate: invitePersonModel = {
          Cmpy:"", 
          UserId:"",
          Phone:"",
          EventHeaderId: "0",
          MemberId: item.MemberId,
          Email: item.Email,
          Comment: "",
          Permission: "",
          Status: ParamEventStatus.Open,
        };
        InitDataPerson.push(personDate);
      });

      let InitDataSechedule: Array<inviteAvailableTimeInterface> = [
      ];

      inviteDate.value.forEach((item: inviteDateModel, index: any) => {
        item.Time.forEach((timeItem: invitaDateTimeModel, TimeIndex: any) => {
          let TimeDate: inviteAvailableTimeInterface = {
            EventHeaderId: "0",
            EventScheduleId: "0",
            ScheduleStartUTCDateTime: new Date(
              timeItem.StartTime
            ).toISOString(),
            ScheduleEndUTCDateTime: new Date(timeItem.EndTime).toISOString(),
          };
          InitDataSechedule.push(TimeDate);
        });
      });

      if (props.actionModal == "I") {
        if (
          inviteInfo.value.EventName == "" ||
          inviteInfo.value.EventContext == "" ||
          inviteInfo.value.ReplayDealine == null
        ) {
          message.info("請維護會議基本資訊");
        } else if (invitMember.value.length == 0) {
          message.info("請維護會議人員");
        } else if (inviteDate.value.length == 0) {
          message.info("請維護會議時間");
        } else {
          loadingRef.value = true

          await store.dispatch(
            hosterModule.desc + hosterActions.SubmitHosterDate,
            { E: InitData, P: InitDataPerson, S: InitDataSechedule }
          );
          await store.dispatch(Module.desc + Actions.HandMyHostingEvents);

          await store.dispatch(
            Module.desc + Actions.UpdateReloadParticipantEventsFlag,
            true
          );
          
          loadingRef.value = false
          onClose();
        }
      } else if (props.actionModal == "U") {
        InitData.EventHeaderId = inviteInfo.value.EventHeaderId;
        loadingRef.value = true
        // 移除舊scheduler時間
        InitDataSechedule.forEach((val:inviteAvailableTimeInterface, id: number)=>
        {
          let flag: boolean = false;
          inviteScheduler.value.forEach((sVal: inviteDateModel, SId: number) => {
            sVal.Time.forEach((sTimeVal: invitaDateTimeModel, STimeId: number) => {
              if (dayjs( sTimeVal.StartTime).isSame(dayjs( val.ScheduleStartUTCDateTime)))
              {
                flag = true;
              }
            })
          })
          if(flag){
            InitDataSechedule.splice(id,1);
          }
          flag = false;
        })
        await store.dispatch(
          hosterModule.desc + hosterActions.UpdateHosterDate,
          { E: InitData, P: InitDataPerson, S: InitDataSechedule }
        );
        await store.dispatch(Module.desc + Actions.HandMyHostingEvents);

        store.dispatch(
          Module.desc + Actions.UpdateReloadParticipantEventsFlag,
          true
        );
        
        loadingRef.value = false
        onClose();

      }
    }
    const bodyStyle = {
      width: "70%",
    };

    return {
      bodyStyle,
      segmented: {
        content: "soft",
        footer: "soft",
      },
      currentStatus: ref("process"),
      current: currentRef,
      next() {
        if (currentRef.value === null) currentRef.value = 1;
        else if (currentRef.value >= 4) currentRef.value = null;
        else currentRef.value++;
      },
      prev() {
        if (currentRef.value === 0) currentRef.value = null;
        else if (currentRef.value === null) currentRef.value = 4;
        else currentRef.value--;
      },
      props,
      onClose,
      currentRef,
      onSubmit,
      invitMember,
      inviteDate,
      loadingRef,
      themeVars,
      stepThemeOverrides
    };
  },
});
